import React, { useEffect } from "react";
import loadable from "@loadable/component";
import APIS from "../../contants/Endpoints";
import useGetHook from "../../customHooks/useGetHook";
import { useParams } from "react-router-dom";
import usePatchHook from "../../customHooks/usePatchHook";
import Spinner from "../../components/Reuseable/Spinner";
import { useForm } from "react-hook-form";
import { productFormValidation } from "../../utils/formValidation";
import { yupResolver } from "@hookform/resolvers/yup";

const EditProductComponent = loadable(
  () => import("../../components/Product/EditProduct")
);
type Props = {};

const EditProduct = (props: Props) => {
  const { id } = useParams();
  
  const { data: categoryData, isPending: categoryLoading } = useGetHook({
    queryKey: ["category"],
    url: `${APIS.CATEGORY}`,
    params: {},
  });

  const { data: singleProductData, isPending: singleProductLoading } =
    useGetHook({
      queryKey: [`product${id}`],
      url: `${APIS.PRODUCT}${id}/`,
      params: {},
    });

  const { mutateAsync } = usePatchHook({
    queryKey: ["product", `product-${id}`],
    navigateURL: "/product",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm({
    resolver: yupResolver(productFormValidation),
    defaultValues: {
      name: "",
      code: "",
      category: "",
      weight: "",
      selling_price: "",
    },
  });

  useEffect(() => {
    if (singleProductData) {
      reset({
        name: singleProductData?.name ?? "",
        code: singleProductData?.code ?? "",
        category: singleProductData?.category?.id ?? "",
        weight: singleProductData?.weight ?? "",
        selling_price: singleProductData?.rate ?? "",
      });
    }
  }, [singleProductData, reset]);

  const handleProductUpdate = async (values: any) => {
    const url = `${APIS.PRODUCT}${id}/`;
    const formData = {
      name: values.name,
      code: values.code,
      category: values?.category,
      rate: values?.selling_price,
      weight: values?.weight,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {singleProductData && categoryData ? (
        <EditProductComponent
          categoryData={categoryData}
          handleProductUpdate={handleProductUpdate}
          singleProductData={singleProductData}
          register={register}
          handleSubmit={handleSubmit}
          errors={errors}
        />
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default EditProduct;
